/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ facet: NonNullable<unknown> }} Exercise_Filter_OptionsInputs */

const en_us2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.facet} options`)
};

const pt_br2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opções de ${i?.facet}`)
};

const es_419_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opciones de ${i?.facet}`)
};

const pt_pt2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opções de ${i?.facet}`)
};

const fr_fr2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Options : ${i?.facet}`)
};

const de_de2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Optionen für ${i?.facet}`)
};

const it_it2_exercise_filter_options = /** @type {(inputs: Exercise_Filter_OptionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opzioni di ${i?.facet}`)
};

/**
* | output |
* | --- |
* | "{facet} options" |
*
* @param {Exercise_Filter_OptionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filter_options = /** @type {((inputs: Exercise_Filter_OptionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filter_OptionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filter_options(inputs)
	if (locale === "es-419") return es_419_exercise_filter_options(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filter_options(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filter_options(inputs)
	if (locale === "de-DE") return de_de2_exercise_filter_options(inputs)
	if (locale === "it-IT") return it_it2_exercise_filter_options(inputs)
	return en_us2_exercise_filter_options(inputs)
});
export { exercise_filter_options as "exercise.filter_options" }